import React from 'react';
import { useAppSelector } from '../../app/hooks';
import { ArgumentList } from '../../features/arguments/ArgumentList';


export function Seesaw() {
    const balance = useAppSelector(state => {
        let balance = state.arguments.pro1.length * 1
            + state.arguments.pro2.length * 2
            + state.arguments.pro3.length * 3
            - state.arguments.con1.length * 1
            - state.arguments.con2.length * 2
            - state.arguments.con3.length * 3;
        balance = Math.max(balance, -5);
        balance = Math.min(balance, 5);
        return balance;
    });

    return <div className="seesaw" style={{ transform: `rotate(${-balance}deg)` }}>
        <div className="sorted-lists">
            <ArgumentList listKey='pro3' factor="+3" />
            <ArgumentList listKey='pro2' factor="+2" />
            <ArgumentList listKey='pro1' factor="+1" />
            <ArgumentList listKey='con1' factor="-1" />
            <ArgumentList listKey='con2' factor="-2" />
            <ArgumentList listKey='con3' factor="-3" />
        </div>
        <div className="beam" />
    </div>;
}
